module.exports = __webpack_public_path__ + "media/images/sprite/ico-instagram@2x-538f9e0f61e9bb0c41813871487ac1e5.png";